var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 104,
    viewBox: "0 0 105 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2734 104C80.9922 104 104.273 80.7188 104.273 52C104.273 23.2812 80.9922 0 52.2734 0C23.5546 0 0.273438 23.2812 0.273438 52C0.273438 80.7188 23.5546 104 52.2734 104Z",
    fill: "url(#paint0_linear_7158_12827)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.8219 35.0134L71.438 34.6235C66.6728 29.7931 58.9513 29.7909 54.1844 34.6246L52.9928 35.8323C52.3681 36.4654 51.3634 36.4726 50.732 35.8323L49.5404 34.6246C44.7762 29.7931 37.0481 29.7959 32.2867 34.6235L31.9029 35.0134C26.5168 40.4746 26.5179 49.3315 31.8995 54.7871L49.6044 72.7395C50.8516 74.0046 52.8676 74.0096 54.1198 72.7395L71.8247 54.7871C77.2091 49.3282 77.2108 40.4769 71.8219 35.0134Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7158_12827",
    x1: 0.273435,
    y1: 104,
    x2: 104.273,
    y2: 0.00000329316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#264653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43971,
    stopColor: "#2A9D8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C46A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.b68132c9.svg";
export { ForwardRef as ReactComponent };